import type { AddOnRequest, AddOnRequestResponse, RequestedStatus } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetAddOnRequests";

interface UpdateAddOnRequestStatusArgs {
  addOnRequestId: string;
  requestedStatus: RequestedStatus;
}

export const useUpdateAddOnRequestStatus = (
  useMutationOptions?: UseMutationOptions<AddOnRequest, Error, UpdateAddOnRequestStatusArgs>,
) => {
  const queryClient = useQueryClient();

  return useMutation<AddOnRequest, Error, UpdateAddOnRequestStatusArgs>({
    mutationFn: async ({ addOnRequestId, requestedStatus }) => {
      const response: AxiosResponse<AddOnRequestResponse> = await learningServiceRequest({
        method: "patch",
        url: `/add_ons/request/${addOnRequestId}/`,
        payload: { requested_status: requestedStatus },
      });
      return response.data.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
    ...useMutationOptions,
  });
};
